<script setup>
import { formatNewsDay } from '~/utils/format-news-date';
import NewsItem from '~/components/news-page/news-page-item/news-page-item.vue';
import { computed } from '#imports';
import groupBy from 'lodash-es/groupBy';

const props = defineProps({
  data: {
    type: Array,
    required: true,
  },
  chroniclesData: {
    type: Array,
    default: () => [],
  },
  highlight: {
    type: String,
    default: '',
  },
});

const sortByPublishDate = computed(() =>
  groupBy(props.data, (news) => new Date(news.publishedAt).toDateString())
);

const chroniclesData = computed(() => props.chroniclesData);
</script>

<template>
  <div class="news-group">
    <div v-if="chroniclesData.length > 0">
      <h2 class="news-group__title">Сейчас</h2>
      <div class="news-group__content">
        <div
          v-for="news in chroniclesData"
          :key="news._id"
          class="news-group__item"
        >
          <NewsItem
            :highlighted-word="highlight"
            :title="news.title"
            :date="news._updatedAt"
            :slug="news.slug ? news.slug.current : ''"
            :border="true"
          />
        </div>
      </div>
    </div>

    <div
      v-for="(newsGroup, date) in sortByPublishDate"
      :key="date"
      class="news-group__wrapper"
    >
      <h2 class="news-group__title">{{ formatNewsDay(date) }}</h2>
      <div class="news-group__content">
        <div v-for="news in newsGroup" :key="news._id" class="news-group__item">
          <NewsItem
            :highlighted-word="highlight"
            :title="news.title"
            :date="news.publishedAt"
            :slug="news.slug ? news.slug.current : ''"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="postcss">
.news-group {
  display: flex;
  flex-direction: column;
  gap: 36px;

  &__wrapper {
    display: flex;
    flex-direction: column;
    gap: 24px;

    @media (--tablet-vp) {
      gap: 8px;
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  &__title {
    font-size: 20px;
  }
}
</style>
